<template>
  <div>
    <div class="container grid grid-cols-3 gap-8 lg:grid-cols-1">
      <div v-for="(a, index) in list" :key="index" @click="getDetail(a.id, index)" class="bg-gray-200 rounded-lg p-4 cursor-pointer">
        <span @click="openGoogleMaps(a.address)" class="text-sm underline block mb-4 font-bold">{{a.address}}</span>
        <span class="block text-sm mb-2 pb-2 border-b-[1px] border-solid border-gray-400"><strong class="font-semibold">Cliente:</strong> {{a.client.name}}</span>
        <span class="block text-sm mb-2 pb-2 border-b-[1px] border-solid border-gray-400"><strong class="font-semibold">Cantidad de paquetes:</strong> {{a.itemsQuantity}}</span>
        <span class="block text-sm"><strong class="font-semibold">Fecha de recojo:</strong> {{a.pickUpDate}}</span>
      </div>
    </div>

    <!---Detail--->
    <div class="fixed top-0 bottom-0 left-0 right-0 bg-white overflow-auto " :class="{'hidden': !showDetail}">
       <div class="container">
         <!---Buttons--->
         <div class="grid gap-4 mb-8">
           <button @click="done('ok')" class="btn">Recojo satisfactorio</button>
           <button @click="done('canceled')" class="btn btn--outline">Anular</button>
           <button class="btn btn--outline" @click="showDetail = false">Cerrar</button>
         </div>
         <!---End--->

         <!---Search-->
         <div class="search mb-8">
           <svg class="search__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
             <circle cx="11" cy="11" r="8"></circle>
             <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
           </svg>
           <input id="search"
                  name="search"
                  v-model="search"
                  class="input"
                  :class=" {'show': showSearch}" type="text"
                  placeholder="Buscar por nombre">
         </div>
         <!--End-->
         <div class="grid grid-cols-3 gap-8 lg:grid-cols-1 pb-8">
          <div v-for="(o, index) in filteredList" :key="index" class="bg-gray-200 rounded-lg p-4 cursor-pointer">
            <span class="text-sm block mb-4 font-bold">{{o.fullName}}</span>
            <span class="text-sm block mb-4">{{o.address}}</span>
            <span class="text-sm block mb-4">{{o.correlative}}</span>
            <span class="text-sm block mt-8 underline" @click="deleteDetailItem(o.id)">Eliminar</span>
          </div>
         </div>
      </div>
    </div>
    <!---End--->
  </div>
</template>

<script>
import { db, Timestamp, auth } from '@/firebase/firebaseConfig'
import moment from 'moment'
export default {
  name: 'Assignments',
  components: {
  },
  data () {
    return {
      list: [],
      cancelled: [],
      detail: [],
      currentSelectedIndex: -1,
      showDetail: false,
      search: '',
      showSearch: true
    }
  },
  async created () {
    this.$store.dispatch('setUser') // Set in store
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    filteredList () {
      return this.detail.filter(o => {
        return o.fullName.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  watch: {
    async user (val) {
      try {
        if (val) {
          // Set start date
          const startDate = new Date()
          const endDate = new Date()
          startDate.setHours(0)
          startDate.setMinutes(0)
          startDate.setSeconds(0)
          // Set end date
          endDate.setHours(23)
          endDate.setMinutes(59)
          endDate.setSeconds(0)

          let startTimes = null
          let endTimes = null
          // End

          startTimes = Timestamp.fromDate(startDate)
          endTimes = Timestamp.fromDate(endDate)

          // Get assigments of firestore

          const querySnapshot = await db.collection('assignments')
            .where('pickUpDate', '>=', startTimes)
            .where('pickUpDate', '<=', endTimes)
            .where('dealer.uid', '==', auth.currentUser.uid)
            .where('state', '==', true)
            .where('status', '==', 'send')
            .orderBy('pickUpDate', 'asc')
            .get()

          querySnapshot.forEach((doc) => {
            const obj = {
              ...doc.data(),
              pickUpDate: doc.data().pickUpDate.toDate(),
              createdAt: doc.data().createdAt.toDate()
            }

            obj.id = doc.id

            obj.pickUpDate = moment(obj.pickUpDate).format('YYYY-MM-DD')
            obj.createdAt = moment(obj.createdAt).format('YYYY-MM-DD HH:mm')

            this.list.push({
              ...obj
            })
          })
          // End
        }
      } catch (e) {
        console.log(e)
        this.$toast.error('Error al cargar datos', {
          duration: 6000
        })
      } finally {
        this.$store.dispatch('hideProgress')
      }
    }
  },
  methods: {
    /**
     * Open google maps
     */
    openGoogleMaps (address) {
      const encodedAddress = encodeURIComponent(address)
      const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${
encodedAddress
}`
      window.open(googleMapsUrl, '_blank')
    },
    /**
     * Get detail
     */
    async getDetail (id, index) {
      try {
        this.$store.dispatch('showProgress')
        this.showDetail = true
        this.detail = []
        this.cancelled = []
        this.currentSelectedIndex = index
        const querySnap = await db.collection('assignments').doc(id).collection('detail').get()
        querySnap.forEach((doc) => {
          this.detail.push({
            ...doc.data()
          })
        })
      } catch (e) {
        this.$toast.error('Error al cargar detalle', {
          duration: 6000
        })
      } finally {
        this.$store.dispatch('hideProgress')
      }
    },
    /**
     * Delete detail item
     */
    deleteDetailItem (detailId) {
      const findIndex = this.detail.findIndex((o) => o.id === detailId)
      this.cancelled.push(this.detail[findIndex])
      this.detail.splice(findIndex, 1)
    },
    /**
     * Confirm detail
     */
    async done (type) {
      try {
        this.$store.dispatch('showProgress')
        const batch = db.batch()

        this.detail.forEach((d) => {
          const docRef = db.collection('detail').doc(d.id)
          batch.update(docRef, {
            status: type === 'ok' ? 'confirmed' : 'canceled'
          })
        })

        this.cancelled.forEach((d) => {
          const docRef = db.collection('detail').doc(d.id)
          batch.update(docRef, {
            status: 'canceled'
          })
        })

        await batch.commit()

        this.showDetail = false

        // Update assignment status
        await db.collection('assignments').doc(this.list[this.currentSelectedIndex].id).update({
          status: 'done'
        })
        this.list.splice(this.currentSelectedIndex, 1)
        // End

        this.$toast.success('Registros guardados correctamente', {
          duration: 6000
        })
      } catch (e) {
        console.log(e)
        this.$toast.error('Error al guardar detalle', {
          duration: 6000
        })
      } finally {
        this.$store.dispatch('hideProgress')
      }
    }
  }
}
</script>
